export type GuestLoginResponse =
  | { redirect: true }
  | {
      access_token: string;
      expires_in?: number;
      refresh_token?: string;
      token_type?: string;
      scope?: string;
    };

export async function guestLogin(
  email: string,
  affiliateId?: string | null
): Promise<GuestLoginResponse> {
  const res = await fetch('/api/auth/guest-login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, affiliateId: affiliateId || undefined }),
    // Let the app/environment attach cookies if needed; tokens are returned in body
    credentials: 'include',
  });
  if (!res.ok) {
    const errorMessage = (await res.json())?.message || `Unable to start session`;
    throw { status: res.status, message: errorMessage };
  }
  const data = (await res.json()) as GuestLoginResponse;
  return data;
}

export function setAuthTokens(accessToken: string, refreshToken?: string, codeVerifier?: string) {
  try {
    localStorage.setItem('access_token', accessToken);
    if (refreshToken) localStorage.setItem('refresh_token', refreshToken);
    if (codeVerifier) localStorage.setItem('code_verifier', codeVerifier);
  } catch {}
}
